// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var foldlM = function (dictApplicative) {
    return function (dictBind) {
        return function (f) {
            return function (i) {
                return function (xs) {
                    var v = Data_Array.uncons(xs);
                    if (v instanceof Data_Maybe.Just) {
                        return Control_Bind.bind(dictBind)(f(i)(v.value0.head))(function (next) {
                            return foldlM(dictApplicative)(dictBind)(f)(next)(v.value0.tail);
                        });
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return Control_Applicative.pure(dictApplicative)(i);
                    };
                    throw new Error("Failed pattern match at Chip.Utils (line 25, column 17 - line 27, column 20): " + [ v.constructor.name ]);
                };
            };
        };
    };
};
var addIndex = function (a) {
    return Data_Array.mapWithIndex(function (i) {
        return function (v) {
            return {
                i: i,
                v: v
            };
        };
    })(a);
};
module.exports = {
    addIndex: addIndex,
    foldlM: foldlM
};
